import { Box, Flex, Fade } from "@chakra-ui/react";
import LaunchdeckButton from "../../../global/components/helper-components/components/LaunchdeckButton";
import { useHistory } from "react-router-dom";
import { displayEmoji } from "../../../digital-sales-room/helpers/dsr-helpers";

export default function ExistingUserSignupContent({ processedEmail }) {
  const history = useHistory();
  return (
    <Flex w='100%' pt='2em' justify='center'>
      <Fade in={true}>
        <Box textAlign='center' pt='3em' maxW='700px' mx='auto' bg='white' p='2em' boxShadow={'xs'}>
          <Flex fontSize='1.5em' fontWeight='600' color='brandDark.500' gap='0.5em' justify='center' align='center'>Hello again {displayEmoji('wave','1em')} </Flex>
          <Box fontSize='1em' fontWeight='600' color='brandDark.500' mt='3.5em'>It appears you already have an account with us </Box>
          <Box color='brandDark.500' fontSize='0.875em' mt='0.2em'>
            Let's get you logged in
          </Box>
          <Flex direction='column' mt='1em' justify='center' alignItems='center'>

            <Flex justify='center' minW='250px' mt='1em'>
              <LaunchdeckButton w='100%' bg='brand.500' color='white' onClick={() => {
                history.push(`/login`, {
                  prepopEmail: processedEmail,
                  fixedEmailEntry: true
                })
              }} label='Log in to account' />
            </Flex>
          </Flex>

        </Box>
      </Fade>
    </Flex>
  )
}